module.exports = new __parcel__URL__("logout.3b6200ba.svg").toString();